export const colors = {
  // New Brand Colors
  primary25: ' #F3F9FE',
  primary50: ' #E8F2FD',
  primary100: ' #D1E6FB',
  primary200: ' #A2CCF7',
  primary300: ' #74B3F2',
  primary: ' #008CFF',
  primary600: ' #1266BB',

  // Neutral Colors
  blackLight: ' #191A1B', // background of the app
  greyHiperDark: ' #161618',
  greyUltraDark: ' #1C1C1E',
  greyDark: ' #2C2C2E',
  grey: ' #83898F',
  greyMedium: ' #AEB3B7',
  greyLight: ' #E4E6E9',
  greyUltraLight: ' #F2F4F7',
  greyHiperLight: ' #F7F9FB',

  // Other Colors
  yellow: ' #F7D000',
  green: ' #56BD23',
  red: ' #FF4B4B',
  orange: ' #FFAE00',

  // General
  transparent: 'transparent',
  black: ' #000000',
  white: ' #FFFFFF', // background of a component on light mode
};

const supersetColors = [
  { bold: ' #9658E2', light: ' #EFE2FF' },
  { bold: ' #43C616', light: ' #F2FAF2' },
  { bold: ' #DD1818', light: ' #FFEEEE' },
  { bold: ' #E2B335', light: ' #FFFBE0' },
  { bold: ' #E26AE9', light: ' #FEF0FF' },
  { bold: ' #4A4A4A', light: ' #F8F8F8' },
  { bold: ' #FF8787', light: ' #FFEEEE' },
  { bold: ' #203CF4', light: ' #F3F5FF' },
  { bold: ' #28C2D3', light: ' #E8F5F7' },
  { bold: ' #A2B139', light: ' #F3F6DD' },
];

export const getSupersetColor = (id: number): string => {
  const normalizedId = id % supersetColors.length;

  return supersetColors[normalizedId].bold;
};
